
export function showCharts (services, getMetricData, boxId) {

  const metricData = getMetricData();
  const currentBox = metricData.graph_boxes[boxId];

  if(currentBox){
    var previousBoxButtonsIds = [];
    var previousBoxButtonsContent = [];
    var displayPreviousBoxButtonsGraph = false;
    var displayCurrentBoxButtonsGraph = false;

    for (const button of currentBox.previous_boxes_buttons){
      if (metricData.daily_clicks[button.id]){
        displayPreviousBoxButtonsGraph = true;
      }
      previousBoxButtonsIds.push(button.id);
      previousBoxButtonsContent.push(button.content);
    }

    var currentBoxButtonsIds = [];
    var currentBoxButtonsContent = [];
    for (const button of currentBox.current_box_buttons){
      if (metricData.daily_clicks[button.id]){
        displayCurrentBoxButtonsGraph = true;
      }
      currentBoxButtonsIds.push(button.id);
      currentBoxButtonsContent.push(button.content);
    }

    if(displayPreviousBoxButtonsGraph || displayCurrentBoxButtonsGraph){
      services.$mdDialog.show({
        'controller': 'chartsController',
        'template': require('./charts.dialog.html'),
        'clickOutsideToClose': true,
        'locals': {
          'metricData': metricData,
          'previousBoxButtonsIds': previousBoxButtonsIds,
          'previousBoxButtonsContent': previousBoxButtonsContent,
          'currentBoxButtonsIds': currentBoxButtonsIds,
          'currentBoxButtonsContent': currentBoxButtonsContent,
          'displayPreviousBoxButtonsGraph': displayPreviousBoxButtonsGraph,
          'displayCurrentBoxButtonsGraph': displayCurrentBoxButtonsGraph
        }
      });
    } else {
      showNoDataDialog(services);
    }
  } else {
    showNoDataDialog(services);
  }

}

function showNoDataDialog(services){
  let alert = services.$mdDialog.alert({
    title : services.$translate.instant('scenario/metric/clicks/no-data-title'),
    textContent : services.$translate.instant('scenario/metric/clicks/no-data-message'),
    ok : services.$translate.instant('close')
  });
  services.$mdDialog.show(alert);
}